/** @format */

import { useEffect } from 'react';
import { resetContentDetail, viewContentDetail } from 'src/slices/topics';
import { useDispatch, useSelector } from 'src/store';

export default function useExtranetContentDetailState(contentID, locale) {
  const dispatch = useDispatch();
  const { error: globalError, globalLoading } = useSelector(state => state.global);
  const { contentDetail, contentDetailLoading, contentDetailError } = useSelector(state => state.topics);

  useEffect(() => {
    if (!contentID) return;
    dispatch(viewContentDetail(contentID, locale));
  }, [contentID, locale, dispatch]);

  useEffect(() => {
    return () => {
      dispatch(resetContentDetail());
    };
  }, [dispatch]);

  const isLoading = globalLoading || contentDetailLoading;
  const shouldShowSkeleton = isLoading && !contentDetail;
  const shouldDimDetail = isLoading && Boolean(contentDetail) && String(contentDetail.id) === String(contentID);
  const title = contentDetail?.title || '';
  const hasFatalError = Boolean(globalError || contentDetailError || !contentID);

  return {
    contentDetail,
    isLoading,
    shouldShowSkeleton,
    shouldDimDetail,
    title,
    hasFatalError
  };
}
